export default function InowebSection() {
  return (
    <section className="py-16 px-4" aria-labelledby="inoweb-heading">
      <div className="max-w-2xl mx-auto text-center">
        <h2 id="inoweb-heading" className="text-lg font-semibold text-gray-700">
          Custom Web Development
        </h2>
        <p className="mt-2 text-gray-400 text-sm">
          Need a custom web application or digital solution?
        </p>
        <p className="mt-1 text-gray-500 text-sm">
          Built by{' '}
          <span className="font-medium text-gray-700">Inoweb</span>
        </p>
        <a
          href="https://inoweb.co.uk"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center mt-4 px-5 py-2 rounded-full border border-gray-200 text-sm text-gray-600 font-medium hover:border-brand-300 hover:text-brand-600 transition-colors"
        >
          Contact Us
        </a>
      </div>
    </section>
  );
}
